import * as React from 'react';
import cx from 'classnames';
import H5Orientation from '@src/components/h5-orientation';
import Orientation from '@src/components/orientation';
import styles from './index.less';
import reload from '../../utils/reload';
// import deferLoadBetterQuicklink from '@src/utils/defer-load-better-quicklink';
export default class Root extends React.PureComponent {
  mainRef = React.createRef();
  resizeObserver = null;
  state = {
    isOrientationChanged: false,
    initWidth: 0,
    newWidth: 0
  };

  componentDidMount () {
    const mainEl = this.mainRef.current;
    mainEl && (mainEl.scrollTop = 0);

    this.setState({
      initWidth: document.body.clientWidth
    });

    this.updateOrientation();
    window.addEventListener('resize', this.updateOrientation);
    window.screen.orientation && window.screen.orientation.addEventListener('change', this.updateOrientation);
    
    // 检查浏览器是否支持ResizeObserver
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.updateOrientation);
      this.resizeObserver.observe(mainEl);
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateOrientation);
    window.screen.orientation && window.screen.orientation.removeEventListener('change', this.updateOrientation);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  updateOrientation = () => {
    let type = null;
    if (window.screen.orientation) {
      type = window.screen.orientation.type;
    }
    //  landscape-primary（横屏模式）、 landscape-secondary（反向横屏模式）、portrait-primary（竖屏模式）或 portrait-secondary（反向竖屏模式）

    const isOrientationChanged = type === 'landscape-primary' || type === 'landscape-secondary' || window.orientation === -90 || window.orientation === 90;
    
    this.setState({ isOrientationChanged, newWidth: document.body.clientWidth });
    if (this.state.newWidth !== this.state.initWidth && !this.state.isOrientationChanged) {
      reload();
    }
  };

  render () {
    const { className, children } = this.props;
    const { isOrientationChanged } = this.state;

    return (
      <div className={cx(styles.root, className)}>
        {/* {isOrientationChanged && <H5Orientation />} */}
        {isOrientationChanged && <Orientation />}
        <div ref={this.mainRef} className={styles.main}>
          {children}
        </div>
      </div>
    );
  }
}
